import { PartialAddress } from '@dreryk/address-common-api';
import { PatientEntitlementStatementCreateCommand } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { Range, Slot } from '@dreryk/watermelon';

import { createIdentityDocumentFromFormPart } from '../identityDocument/IdentityDocumentFormSection';
import { entitlementStatementsTranslationKeys } from '../translations';

import { PatientEntitlementStatementCreateFormBean } from './create/form/PatientEntitlementStatementCreateForm';

// eslint-disable-next-line max-lines-per-function
export const useCreatePatientEntitlementStatement = (
   patientId: number,
   onDataChanged: VoidFunction
): UseCqrsCommandResult<number, PatientEntitlementStatementCreateFormBean> => {
   return useCqrsCommand<number, PatientEntitlementStatementCreateFormBean>(
      (parameters) => {
         const command = new PatientEntitlementStatementCreateCommand();
         command.effectiveDate = parameters.effectiveDate!;
         command.legalBasis = parameters.legalBasis!.value;
         command.patientAddress = PartialAddress.builder()
            .withPostcode(parameters.postcode)
            .withTown(parameters.town)
            .withStreet(parameters.street)
            .withBuilding(parameters.house)
            .withFlat(parameters.flat)
            .build();
         command.patientId = patientId;
         command.patientIdentityDocument = createIdentityDocumentFromFormPart(parameters.identityDocument)!;
         command.submissionDate = parameters.submissionDate!;

         if (parameters.grantingDateFieldEnabled) {
            command.providingDateRange = Slot.of(
               Range.closed(parameters.grantingDate.lowerEndpoint(), parameters.grantingDate.upperEndpoint())
            );
         }

         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(entitlementStatementsTranslationKeys.createModal.documentAdded, {
               autoHideDelayInMs: 10000,
            });
            onDataChanged();
         },
      }
   );
};
